import React from 'react';
import googleMapsLogo from '../../assets/logos/google-maps-logo.svg';

// Google requires its unmodified logo (16-19px tall) next to Places content shown
// without a map: https://developers.google.com/maps/documentation/places/web-service/policies
const GoogleMapsAttribution: React.FC = () => (
  <img src={googleMapsLogo} alt="Google Maps" className="h-[18px] w-auto" translate="no" />
);

export default GoogleMapsAttribution;
